export default "__VITE_ASSET__CllH829t__"